import Router from 'ampersand-router';
import actions from './actions/FavoritesActions';
import { portfolioTypes, slugify, tabs } from './constants';

export default Router.extend({
    routes: {
        'folders/:folderUrlLabel/:folderId': 'folder',
        'folders(/)': 'folders',
        'following(/)': 'following',
        'items(/)': 'items',
        'projects(/)': 'projects',
        'project/:projectId/:folderId(/)': 'project',
    },
    initialize(options) {
        this.store = options.store;
        this.queue = options.queue;

        let prevTab = this.store.getState().favorites.uiState.tab;
        options.store.subscribe(() => {
            const { uiState } = this.store.getState().favorites;
            const { portfolioIds, portfolioName, projectId, tab } = uiState;
            if (tab !== prevTab) {
                this.queue.runNotificationQueue();
                prevTab = tab;
                let route;
                switch (tab) {
                    case tabs.FOLDER:
                        if (portfolioIds === '') {
                            route = `/${tabs.ITEMS}/`;
                        } else {
                            route = slugify(portfolioName, portfolioIds);
                        }
                        break;
                    case tabs.FOLDERS:
                        route = `/${tabs.FOLDERS}/`;
                        break;
                    case tabs.FOLLOWING:
                        route = `/${tabs.FOLLOWING}/`;
                        break;
                    case tabs.ITEMS:
                        route = `/${tabs.ITEMS}/`;
                        break;
                    case tabs.PROJECTS:
                        route = `/${tabs.PROJECTS}/`;
                        break;
                    case tabs.PROJECT:
                        route = `/${tabs.PROJECT}/${projectId}/${portfolioIds[0]}/`;
                        break;
                }
                this.navigate(route, { trigger: false });
            }
        });
    },
    resetTab() {
        this.store.dispatch(actions.resetCreationState());
        this.store.dispatch(actions.resetEditInlineState());
        this.store.dispatch(actions.resetEmailState());
        this.store.dispatch(actions.resetModalState());
        this.store.dispatch(actions.resetUiState());
    },
    folder(folderUrlLabel, folderId) {
        this.resetTab();
        this.store.dispatch(actions.setTab({ tab: tabs.FOLDER }));
        this.store.dispatch(actions.setPortfolioIds({ portfolioIds: [folderId] }));
        this.store.dispatch(actions.setPortfolioName({ portfolioName: folderUrlLabel }));
        this.store.dispatch(actions.setProjectId({ projectId: '' }));
        this.store.dispatch(actions.routerNavigation({ routerNavigation: true }));
    },
    folders() {
        this.resetTab();
        this.store.dispatch(actions.setTab({ tab: tabs.FOLDERS }));
        this.store.dispatch(actions.setPortfolioIds({ portfolioIds: [] }));
        this.store.dispatch(actions.setPortfolioTypes({ portfolioTypes: [portfolioTypes.FOLDER] }));
        this.store.dispatch(actions.setProjectId({ projectId: '' }));
        this.store.dispatch(actions.routerNavigation({ routerNavigation: true }));
    },
    following() {
        this.resetTab();
        this.store.dispatch(actions.setTab({ tab: tabs.FOLLOWING }));
        this.store.dispatch(actions.setProjectId({ projectId: '' }));
        this.store.dispatch(actions.routerNavigation({ routerNavigation: true }));
    },
    items() {
        this.resetTab();
        this.store.dispatch(actions.setTab({ tab: tabs.ITEMS }));
        this.store.dispatch(actions.setPortfolioTypes({ portfolioTypes: [portfolioTypes.ITEMS] }));
        this.store.dispatch(actions.setProjectId({ projectId: '' }));
        this.store.dispatch(actions.routerNavigation({ routerNavigation: true }));
    },
    projects() {
        this.resetTab();
        this.store.dispatch(actions.setTab({ tab: tabs.PROJECTS }));
        this.store.dispatch(actions.setProjectId({ projectId: '' }));
        this.store.dispatch(actions.routerNavigation({ routerNavigation: true }));
    },
    project(projectId, folderId) {
        this.resetTab();
        this.store.dispatch(actions.setProjectId({ projectId }));
        this.store.dispatch(actions.setPortfolioIds({ portfolioIds: [folderId] }));
        this.store.dispatch(actions.setTab({ tab: tabs.PROJECT }));
        this.store.dispatch(actions.routerNavigation({ routerNavigation: true }));
    },
});
